import type { Mission } from '../missions.ts'

export const noaa: Mission = {
  id: "noaa",
  name: "National Oceanic and Atmospheric Administration",
  short: "NOAA",
  call: "Weather",
  kind: "subagency",
  parent: "doc",
  url: "https://www.noaa.gov/",
  established: 1970,
  palette: {
    primary: "#003087",
    secondary: "#0085ca",
    accent: "#80ccec",
  },
  colorSource: {
    kind: "brand-guide",
    url: "https://www.noaa.gov/office-of-communication/about-noaa-emblem-and-logo",
  },
  motif: "wave",
  mission: {
    text: "To understand and predict changes in climate, weather, ocean, and coasts, to share that knowledge and information with others, and to conserve and manage coastal and marine ecosystems and resources.",
    url: "https://www.noaa.gov/about-our-agency",
  },
  fact: {
    text: "NOAA's roots reach back to 1807, when President Thomas Jefferson founded the Survey of the Coast.",
    url: "https://www.noaa.gov/our-history",
  },
  seal: {
    file: "public/seals/noaa.svg",
    source: "https://commons.wikimedia.org/wiki/File:NOAA_logo.svg",
  },
  logo: {
    file: "public/logos/noaa.svg",
    source: "https://commons.wikimedia.org/wiki/File:Noaa-logo-rgb-2022.svg",
  },
  identifier: {
    about: "https://www.noaa.gov/about-our-agency",
    accessibility: "https://www.noaa.gov/accessibility",
    foia: "https://www.noaa.gov/information-technology/foia",
    noFear: "https://www.noaa.gov/organization/inclusion-and-civil-rights/no-fear-act",
    oig: "https://www.oig.doc.gov/",
    performance: "https://www.noaa.gov/budget-finance-performance",
    privacy: "https://www.noaa.gov/protecting-your-privacy",
  },
  media: {
    photos: [
      {
        file: "/media/noaa-okeanos-explorer.jpg",
        small: "/media/noaa-okeanos-explorer-sm.jpg",
        alt: "NOAA Ship Okeanos Explorer, a white research vessel with a radar dome, moored alongside a pier.",
        title: "NOAA Ship Okeanos Explorer",
        creator: "NOAA",
        source: "https://commons.wikimedia.org/wiki/File:NOAA_Ship_Okeanos_Explorer_alongside_NOAA_photo.jpg",
        license: "Public domain (U.S. government work)",
      },
      {
        file: "/media/noaa-hurricane-sandy.jpg",
        small: "/media/noaa-hurricane-sandy-sm.jpg",
        alt: "Satellite view of Hurricane Sandy's vast spiral of clouds over the western Atlantic.",
        title: "GOES East image of Hurricane Sandy, October 2012",
        creator: "NOAA/NESDIS Environmental Visualization Laboratory",
        source: "https://commons.wikimedia.org/wiki/File:GOES_East_image_of_Hurricane_Sandy_(2268-627).jpg",
        license: "Public domain (U.S. government work)",
      },
    ],
    video: {
      webm: "/media/noaa-loop.webm",
      mp4: "/media/noaa-loop.mp4",
      poster: "/media/noaa-loop-poster.jpg",
      title: "Deep-sea hydromedusa (Crossota), Enigma Seamount, Marianas, 2016",
      creator: "NOAA Office of Ocean Exploration and Research",
      source: "https://commons.wikimedia.org/wiki/File:Jellyfish-_2016_Deepwater_Exploration_of_the_Marianas.webm",
      license: "Public domain (U.S. government work)",
    },
  },
}
